module.exports = __webpack_public_path__ + "static/media/16UNODC16.ec31d3e3.jpg";